import round from 'lodash/round';

export const formattedValue = (value: number, unit?: '$' | 'USD') => {
	const num = round(value, 2);
	return unit ? `${['$', 'USD'].includes(unit) ? num.toFixed(2) : num}${unit === 'USD' ? ' ' : ''}${unit}` : num;
};
